import React, { useState } from "react";
import DatePicker from "react-datepicker";

export const AddHoliday = () => {
  const [selectedDate1, setSelectedDate1] = useState(null);

  const handleDateChange1 = (date) => {
    setSelectedDate1(date);
  };

  return (
    <div>
      <div className="modal custom-modal fade" id="add_holiday" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Project</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Project Name <span className="text-danger">*</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Project Date <span className="text-danger">*</span>
                  </label>
                  <div className="cal-icon">
                    <DatePicker
                      selected={selectedDate1}
                      onChange={handleDateChange1}
                      className="form-control datetimepicker"
                      type="date"
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal custom-modal fade" id="edit_holiday" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Project</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Project Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    defaultValue="New Year"
                    type="text"
                  />
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Project Date <span className="text-danger">*</span>
                  </label>
                  <div className="cal-icon">
                    <DatePicker
                      selected={selectedDate1}
                      onChange={handleDateChange1}
                      className="form-control datetimepicker"
                      type="date"
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    type="reset"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// import React, { useState } from "react";
// import DatePicker from "react-datepicker";

// export const AddHoliday = ({ onAddProject }) => {
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [projectName, setProjectName] = useState("");

//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//   };

//   const handleSubmit = () => {
//     if (projectName && selectedDate) {
//       const newProject = {
//         id: Date.now(),
//         Title: projectName,
//         HolidayDate: selectedDate.toISOString().split("T")[0],
//         CreatedBy: "Admin",
//       };
//       onAddProject(newProject); // Pass the new project to parent
//       setProjectName("");
//       setSelectedDate(null);
//     }
//   };

//   return (
//     <div className="modal custom-modal fade" id="add_holiday" role="dialog">
//       <div className="modal-dialog modal-dialog-centered" role="document">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title">Add Project</h5>
//             <button
//               type="button"
//               className="btn-close"
//               data-bs-dismiss="modal"
//               aria-label="Close"
//             />
//           </div>
//           <div className="modal-body">
//             <div className="input-block mb-3">
//               <label className="col-form-label">
//                 Project Name <span className="text-danger">*</span>
//               </label>
//               <input
//                 className="form-control"
//                 type="text"
//                 value={projectName}
//                 onChange={(e) => setProjectName(e.target.value)}
//               />
//             </div>
//             <div className="input-block mb-3">
//               <label className="col-form-label">
//                 Project Date <span className="text-danger">*</span>
//               </label>
//               <div className="cal-icon">
//                 <DatePicker
//                   selected={selectedDate}
//                   onChange={handleDateChange}
//                   className="form-control datetimepicker"
//                   dateFormat="yyyy-MM-dd"
//                 />
//               </div>
//             </div>
//             <div className="submit-section">
//               <button
//                 className="btn btn-primary submit-btn"
//                 data-bs-dismiss="modal"
//                 onClick={handleSubmit}
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
